var _effectorFileName = "/builds/gmini/front-ui-kit/src/SettingSelectButton/SettingSelectButton.tsx";
import { Setting } from '../icons/Setting';
import { Triangle } from '../icons/Triangle';
import { SettingSelectButton as Button, SettingWrapper, TriangleWrapper } from './SettingSelectButton.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SettingSelectButton = ({
  onClick,
  disabled,
  active,
  ...other
}) => /*#__PURE__*/_jsxs(Button, {
  active: active,
  disabled: disabled,
  onClick: onClick,
  ...other,
  children: [/*#__PURE__*/_jsx(SettingWrapper, {
    children: /*#__PURE__*/_jsx(Setting, {})
  }), /*#__PURE__*/_jsx(TriangleWrapper, {
    children: /*#__PURE__*/_jsx(Triangle, {})
  })]
});